import { Component, OnInit, ViewChild } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import Swal from 'sweetalert2'
declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectuée.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectuée. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

import { Router, ActivatedRoute } from '@angular/router';
import { Iec } from 'model/modal-cms/iec';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { IecDetail } from 'model/modal-cms/iec_detail';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { Apropos } from 'model/modal-cms/apropos';
import { Mot_defil } from 'model/modal-cms/mot_defil';
import { Infra } from 'model/modal-cms/infra';
import { CMSService } from '../../../../services/cms-service';
import { AdminService } from '../../../../services/admin';

@Component({
  selector: 'app-detail-epidemie',
  templateUrl: './detail-epidemie.component.html',
  styleUrls: ['./detail-epidemie.component.scss']
})
export class DetailEpidemieComponent implements OnInit {
  loginuserCMSActuel: any;
  mode_ajout: number;
  nbr_covid19: any;
  titre_epidemie: any;
  list_epidemimie: any;
  mode_epidemie_fermer: number;
  mode_epidemie_video: number = 1;
  hatra_actuel: any;
  liste_apropos: any;
  liste_mot_defil: any;
  listecmsdetatil: any;
  listeconseil: any;
  mode_epidemiecovidcmsconseil: number = 1;
  mode_actualiter2: number = 1;
  mode_actualiter: number = 1;
  mode_actualiter_video2: number = 1;
  mode_actualiter_video: number = 1;
  mode_actualiter_slide: number = 1;
  mode_actualiter_slide2: number = 1;
  infoIecInformation: any;
  mode_epidemiecovidcmsconseil2: number;
  default_logo: any = "logo_actualite.jpg";
  logovideodefault: any = "logo_video2.png";
  currentPage: number = 1;
  mode_epidemie_: number = 1;
  mot_cms_Sensibilisation: string = "Sensibilisation";
  gesteBarriere: any;
  date_covid19: Date;
  statistique_actuel: any;
  fileToUmploadImage: File = null;

  urllogoIec_:string ='http://localhost/SiteCmsServeur/FileIEC/upload/img/upload_iec/cms/covid_fond_5.jpg';
  urllogoIec__ = environment.urllogoIec+"/cms/covid_fond_5.jpg";
  id_actuelle: any;
  motCle(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  @ViewChild('popup5') popup5: Popup;
  titre: any = "Coronavirus";
  date_video: any = "7 février 2020";
  // source_video: any = "MADAGASIKARA MIATRIKA NY CORONAVIRUS";
  source_video: any;
  mode_epidemie: number = 4;
  mode_epidemie2: number = 1;
  infoIec: any;
  iec: Iec = new Iec(null);
  imageUrl: string = "logo_video2.png";
  urlphoto: string = "http://localhost/ImageEtudiant/upload";
  fileToUmpload: File = null;
  fileToUmploadFichier: File = null;
  seleCtedFile: any;
  urlServer = environment.urlServerphoto;
  iecDetail: IecDetail = new IecDetail(null)
  epidemimie: Epidemimie = new Epidemimie(null);
  apropos: Apropos = new Apropos(null);
  mot_defil: Mot_defil = new Mot_defil(null);
  mode_epidemieRecherche: number = 1;

  mode_InformationSlide: number = 1;



  infoIecVideo: any;
  @ViewChild('popupProcedure') popupProcedure: Popup;
  @ViewChild('popupConseil') popupConseil: Popup;
  @ViewChild('popupalertepidemie') popupalertepidemie: Popup;
  @ViewChild('popupalertepidemie2') popupalertepidemie2: Popup;
  @ViewChild('popupApropos') popupApropos: Popup;
  @ViewChild('popupModifCovid') popupModifCovid: Popup;
  @ViewChild('popupMotDefil') popupMotDefil: Popup;
  @ViewChild('popupalert') popupalert: Popup;


  urlInfoIec = environment.urlInfoIec;
  urllogoIec = environment.urllogoIec;
  urlfileIec_ = environment.urlfileIec;
  urlVideoIec = environment.urlVideoIec;

  urlfileIec: string = "assets/file/iec";

  urllogoSite: string = this.urllogoIec;

  url_rapport_direct_actuel: string = "https://www.who.int/fr"
  url_rapport_direct_actuel2: string = "https://covid-ams.operanewsapp.com/vmact/active-web/coronavirus/dist/#/?country=mg&language=fr&product=mini"
  collection = [];

  statistique_actu: any;

  infra: Infra = new Infra(null)

  constructor(private router: Router, activatedRoute: ActivatedRoute, public cmsService: CMSService, private adminService: AdminService, private http: HttpClient, ) {
    this.id_actuelle = activatedRoute.snapshot.params['id'];
    for (let i = 1; i <= 100; i++) {
      this.collection.push(`item ${i}`);
    }

    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    this.source_video = this.adminService.getevolution_default_video();

    // this.setDefaultVideo();
    if (this.loginuserCMSActuel == "com_daf") {
      this.mode_ajout = 1;
    } else {
      this.mode_ajout = 11;
    }
  }

  ngOnInit() {
    //this.nbr_covid19 = this.adminService.getevolution_epidemie_actuel();
    // this.hatra_actuel = this.adminService.getehafatrynyfilofa_actuel();
    // this.getIecVideo();
    this.getIecFile();
    this.EvolutionEpidemie();
    this.getinfoipdemie();
    this.getIecInformationUtile();
    if(this.id_actuelle == 1){
      this.mode_epidemie = 2;
      this.getInfoIECMSCOVID();
    }else if (this.id_actuelle == 2){
      this.mode_epidemie = 44;
    }else if (this.id_actuelle == 3){
      this.mode_epidemie = 46;
    }else if (this.id_actuelle == 4){
      this.mode_epidemie = 64;
    } else if (this.id_actuelle == 5){
      this.mode_epidemie = 4;
    }else if (this.id_actuelle == 6){
      this.mode_epidemie = 100;
    }   

  }

  
  setDefaultVideo() {
    let etat = "E_ACTU"
    this.cmsService.getDefaultVideo(etat)
      .subscribe(data => {
        this.source_video = data.fichier_iec
      },
        err => {
          console.log(err);
        })
  }

  getinfoipdemie() {
    let etat = "ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        //this.epidemimie = data
        this.nbr_covid19 = data.text_epid
        this.hatra_actuel = data.hafatra_pst
        this.date_covid19 = this.epidemimie.date_ajout
      },
        err => {
          console.log(err);
        })
  }



  deleteInfoEpidemie(ep: Epidemimie) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteEvolutionEpidemie(ep.id_epid)
          .subscribe(data => {
            this.EvolutionEpidemie();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }


  getIecFile() {
    this.cmsService.getIec("FA")
      .subscribe(data => {
        this.infoIec = data
      },
        err => {
          console.log(err);
        })
  }

  rechercheIec(mcl) {
    if (mcl == "") {
      this.getIecFile();
    } else {
      this.cmsService.getIecParmocle(mcl)
        .subscribe(data => {
          this.infoIec = data
        },
          err => {
            console.log(err);
          })
    }

  }

  getIecVideo() {
    this.cmsService.getIecEpidemique("V", "E")
      .subscribe(data => {
        this.infoIecVideo = data
      },
        err => {
          console.log(err);
        })
  }

  rechercheIECVideo(motCle) {
    if (motCle == "") {
      this.getIecFile();
    } else {
      this.cmsService.getIecParmocle(motCle)
        .subscribe(data => {
          this.infoIecVideo = data
        },
          err => {
            console.log(err);
          })
    }
  }


  //get informatio utile  
  getIecInformationUtile() {
    this.cmsService.getIec("TSA")
      .subscribe(data => {
        
        this.infoIecInformation = data
        console.log(data);
      
      },
        err => {
          console.log(err);
        })
  }


  getInfoIEC(id_iec: number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.Ajouter();
      },
        err => {
          console.log(err);
        })
  }

  ///vahatra *106*0336499869#


  //upload  file etudiant
  onChangeSelectFile(file: FileList) {
    this.fileToUmpload = file.item(0);
    console.log(this.fileToUmpload);
    //show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUmpload);
    // this.mode_add = 1
    // this.selectImage = 2
  }


  //upload  file iec
  onChangeSelectFichier(file: FileList) {
    this.fileToUmploadFichier = file.item(0);
    console.log(this.fileToUmploadFichier);
    //show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUmploadFichier);
    // this.mode_add = 1
    // this.selectImage = 2
  }

  onChangeSelectFile2(event) {
    this.seleCtedFile = event.target.files[0];
    console.log(this.seleCtedFile);
  }




  //uplod logo IEC
  enregistrerFileIEC() {
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmpload, this.fileToUmpload.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer + 'uploadPhotoIEC.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }

  //uplod fichier iec
  enregistrerFichierIEC() {
    const uploadDataichierIEC = new FormData();
    uploadDataichierIEC.append('avatar', this.fileToUmploadFichier, this.fileToUmploadFichier.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer + 'uploadFichierIEC.php', uploadDataichierIEC, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }



  //uplod Image slide iec
  enregistrerFichierSLIDEIEC() {
    const uploadDataichierIEC = new FormData();
    uploadDataichierIEC.append('avatar', this.fileToUmploadFichier, this.fileToUmploadFichier.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer + 'uploadFichierSlideIEC.php', uploadDataichierIEC, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }


  //uplod Image slide iec
  enregistrerVIDEOIEC() {
    const uploadDataichierIEC = new FormData();
    uploadDataichierIEC.append('avatar', this.fileToUmploadFichier, this.fileToUmploadFichier.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer + 'uploadVidoIEC.php', uploadDataichierIEC, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }

  //IEC DETAIL

  getInfoIecDetailConseil() {
    this.getInfoIECDetail2();
    this.mode_epidemiecovidcmsconseil = 2;
  }

  getInfoIecDetailCMSCOVID() {
    this.getInfoIECDetail();
    this.mode_epidemiecovidcmsconseil = 2;
  }






  AjouterIECDetail() {
    if (this.iecDetail.id_detail_iec == null) {
      this.iec.logo_iec = this.default_logo
      this.iecDetail.fichier = this.fileToUmploadFichier.name
      this.iecDetail.iec_id = 1;
      this.cmsService.saveIecDetail(this.iecDetail).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        // this.enregistrerFileIEC();

        this.enregistrerFichierIEC();
        this.getInfoIECMSCOVID();
        this.getInfoIECDetailMSCOVID();
        this.annulerIECCMS();
        success_message.show();
      }, err => {
      })
    } else {
      this.iec.logo_iec = this.default_logo
      if (this.fileToUmploadFichier == null) {

      } else {
        // this.iec.logo_iec = this.fileToUmpload.name
        this.iecDetail.fichier = this.fileToUmploadFichier.name
        // this.enregistrerFileIEC();
        this.enregistrerFichierIEC();
      }
      this.cmsService.updateIecDetail(this.iecDetail).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }

        this.getInfoIECMSCOVID();
        this.getInfoIECDetailMSCOVID();
        this.annulerIECCMS();
        success_message.show();
      }, err => {
      })
    }

  }

  DeleteIecDetail(r: IecDetail) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIecDetail(r.id_detail_iec)
          .subscribe(data => {
            this.getInfoIECMSCOVID();
            this.getInfoIECDetailMSCOVID();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }



  //iec 
  getInfoIECActualiter(id_iec: number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.mode_actualiter2 = 2;
        this.mode_actualiter = 2
      },
        err => {
          console.log(err);
        })
  }

  getInfoIECVideo(id_iec: number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.mode_actualiter_video2 = 2;
      },
        err => {
          console.log(err);
        })
  }

  getInfoIECSlide(id_iec: number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        this.iec = data
        this.mode_actualiter_slide2 = 2;
      },
        err => {
          console.log(err);
        })
  }




  AjouterIEC(id_mode: number) {
    if (this.iec.id_iec == null) {
      this.iec.logo_iec = this.default_logo
      this.iec.fichier_iec = this.fileToUmploadFichier.name
      if (this.iec.etat_iec == "V") {
        this.iec.etat_epid = "E";
        this.iec.logo_iec = this.logovideodefault
      } else {
        this.iec.etat_epid = "";
      }
      this.cmsService.saveIec(this.iec).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        //  this.enregistrerFileIEC();


        if (id_mode == 1) {
          this.enregistrerFichierIEC();
          this.getIecFile();
          this.AnnulerActualiter();
        } else if (id_mode == 2) {
          this.enregistrerVIDEOIEC();
          this.getIecVideo();
          this.AnnulerActualiterVideo();
        } else {
          this.enregistrerFichierSLIDEIEC();
          this.getIecInformationUtile();
          this.AnnulerActualiterSlide();
        }
        success_message.show();
        // this.popup5.hide();
      }, err => {
      })
    } else {
      this.iec.logo_iec = this.default_logo
      if (this.fileToUmploadFichier == null) {
        this.cmsService.updateIec(this.iec).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          if (id_mode == 1) {
            this.getIecFile();
            this.AnnulerActualiter();
          } else if (id_mode == 2) {
            this.getIecVideo();
            this.AnnulerActualiterVideo();
          } else if (id_mode == 3) {
            this.getIecInformationUtile();
            this.AnnulerActualiterSlide();
          }
          success_message.show();
          this.popup5.hide();
        }, err => {
        })

      } else {
        //  this.iec.logo_iec = this.fileToUmpload.name
        this.iec.fichier_iec = this.fileToUmploadFichier.name

        this.cmsService.updateIec(this.iec).subscribe(data => {
          if (data.err) {
            //toastr.error(data.err);return;
          }
          //  this.enregistrerFileIEC();


          if (id_mode == 1) {
            this.enregistrerFichierIEC();
            this.getIecFile();
            this.AnnulerActualiter();
          } else if (id_mode == 2) {
            this.enregistrerVIDEOIEC();
            this.getIecVideo();
            this.AnnulerActualiterVideo();
          } else {
            this.enregistrerFichierSLIDEIEC();
            this.getIecInformationUtile();
            this.AnnulerActualiterSlide();
          }
          success_message.show();
          // this.popup5.hide();
        }, err => {
        })
      }

    }

  }


  DeleteIec(r: Iec) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIec(r.id_iec)
          .subscribe(data => {
            this.getIecFile();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }


  DeleteIecV(r: Iec) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIec(r.id_iec)
          .subscribe(data => {
            this.getIecVideo();
            this.getIecInformationUtile();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }


  details(id: any, f: any) {
    this.router.navigate(['detail-iec/' + id + "/" + f]);
  }




  Ajouter() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter information en cours ",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }

  openVideo(id_vid: any, v: any) {
    this.router.navigate(['detail-iec/' + id_vid + "/" + v]);
  }


  Apropos(id: number, id_2: any) {
    if (id == 1) {
      this.listeApropos();
      this.mode_epidemieRecherche = 2;
      this.mode_epidemie = 2;
      this.mode_epidemie_fermer = 1;
      this.mode_epidemiecovidcmsconseil2 = 22;
      this.popupProcedure.hide();
      this.popupConseil.hide();
    } else if (id == 2) {
      this.titre_epidemie = "CONSEILS";
      this.getInfoIECDetailById(id_2)
      //  this.getInfoIECDetail2();
      this.mode_epidemieRecherche = 2;
      this.open2();
      this.mode_epidemie_fermer = 2;
    } else if (id == 3) {
      this.titre_epidemie = "CMS FACE AU CORONAVIRUS";
      //  this.getInfoIECDetail();
      this.getInfoIECDetailById(id_2)
      this.mode_epidemieRecherche = 2;
      this.open();
      this.mode_epidemie_fermer = 2;
    } else if (id == -1) {
      this.mode_epidemie = 1;
      this.mode_epidemie_fermer = 1;
      this.mode_epidemiecovidcmsconseil2 = 22;
      this.popupProcedure.hide();
      this.mode_epidemieRecherche = 2;
      this.popupConseil.hide();
    } else if (id == -2) {
      this.EvolutionEpidemie();
      this.mode_epidemie = 4;
      this.mode_epidemieRecherche = 1;
      this.mode_epidemie_fermer = 1;
      this.mode_epidemiecovidcmsconseil2 = 22;
      this.popupProcedure.hide();
      this.popupConseil.hide();
    }

  }

  //iec detai by id
  getInfoIECDetailById(id_iec_detail: any) {
    this.cmsService.getInfoIECDetailById(id_iec_detail)
      .subscribe(data => {
        this.mode_epidemiecovidcmsconseil = 2;
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }

  //cms & covid 19"
  getInfoIECDetail() {
    this.cmsService.getInfoIECDetail(1, "C2")
      .subscribe(data => {
        console.log("cms & covid 19" + data)
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }


  //conseil
  getInfoIECDetail2() {
    this.cmsService.getInfoIECDetail(1, "C3")
      .subscribe(data => {
        console.log("conseil" + data)
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }



  //saveEvolutionEpidemie 
  rechercheEvolutionEpidemie(mcl) {
    console.log(mcl)
    if (mcl == "<empty string>") {
      this.EvolutionEpidemie();
    } else {
      this.cmsService.getevolutionepidemieParMotCle(mcl)
        .subscribe(data => {
          this.list_epidemimie = data
        },
          err => {
            console.log(err);
          })
    }
  }


  EvolutionEpidemie() {
    this.cmsService.getevolutionepidemie()
      .subscribe(data => {
        this.list_epidemimie = data
      },
        err => {
          console.log(err);
        })
  }

  getInfoEvolutionEpidemie(id_epi: number, id_autre: any) {
    this.cmsService.getInfoEvolutionEpidemie(id_epi)
      .subscribe(data => {
        this.epidemimie = data
        if (id_autre == 1) {
          this.openalertepidemie();
        } else {
          this.openalertepidemie2();
        }
      },
        err => {
          console.log(err);
        })
  }


  saveEvolutionEpidemie() { 
  
    if (this.epidemimie.id_epid == null) {
      this.epidemimie.etat_epid = "A";
     // this.epidemimie.image_actu = this.fileToUmploadImage.name
     // this.statistique_actu = this.fileToUmploadImage.name
      this.cmsService.saveEvolutionEpidemie(this.epidemimie).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        //this.AjouterImageIEC();
        this.EvolutionEpidemie();
        this.epidemimie = new Epidemimie(null)
        success_message.show();
        this.popupalertepidemie.hide();
      }, err => {
      })
    } else {
      //  if(this.fileToUmploadImage== null || this.fileToUmploadImage == undefined)  {
      //  console.log("tsy nampiditra sary")
      // }else{
      //  this.epidemimie.image_actu = this.fileToUmploadImage.name
      //   this.statistique_actu = this.fileToUmploadImage.name
      //   this.AjouterImageIEC();      
      // }
      this.cmsService.updateEvolutionEpidemie(this.epidemimie).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        //this.AjouterImageIEC();
        this.EvolutionEpidemie();
        this.epidemimie = new Epidemimie(null)
        success_message.show();
        this.popupalertepidemie.hide();
      }, err => {
      })
    }
  }

  //save image & DB
  AjouterImageIEC() {
    this.infra.image_infra = this.statistique_actu;
    this.infra.etat_infra_2 = "P";
    this.infra.etat_infra_3 = "L";
    this.infra.libelle_infra = "CCO COVID-19";
    this.cmsService.saveIecImage(this.infra).subscribe(data => {
      if (data.err) {
        console.log(data.err); return;
      }
      this.enregistrerImageCMS();
      success_message.show();
    }, err => {
    })

  }

  //uplod image CCO COVID-19
  onChangeSelectImage(file: FileList) {
    this.fileToUmploadImage = file.item(0);
    console.log(this.fileToUmploadImage);
    //show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUmploadImage);
  }

  //uplod image CCO COVID-19
  enregistrerImageCMS() {
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmploadImage, this.fileToUmploadImage.name);
    // http://192.168.137.116/UnivServeur/' http://localhost/ImageEtudiant/upload2.php'
    this.http.post(this.urlServer + 'uploadImageCMS.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }




  changeEtatEpidemie() {
    this.epidemimie.etat_epid = "ACTU";
    // console.log(this.fileToUmploadImage);
    // alert(this.fileToUmploadImage);
    // if(this.fileToUmploadImage== null || this.fileToUmploadImage == undefined)  {
    //    console.log("tsy nampiditra sary")
    // }else{
    //   this.epidemimie.image_actu = this.fileToUmploadImage.name
    //   this.statistique_actu = this.fileToUmploadImage.name
    //   this.AjouterImageIEC();      
    // }
    this.cmsService.updateEvolutionEpidemie(this.epidemimie).subscribe(data => {
      if (data.err) {
        //toastr.error(data.err);return;
      }
      this.EvolutionEpidemie();
      this.epidemimie = new Epidemimie(null)
      success_message.show();
      this.popupalertepidemie.hide();
    }, err => {
    })
  }


  AlertCoronaVirus() {
    if (this.loginuserCMSActuel == "com_daf") {
      this.openalertepidemie();
      this.epidemimie = new Epidemimie(null)

    } else {
      this.mode_ajout = 11;
    }
  }

  openalertepidemie() {
    this.popupalertepidemie.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter l'évolution de CORONAVIRUS",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }
    this.popupalertepidemie.show(this.popupalertepidemie.options);
  }

  openalertepidemie2() {
    this.popupalertepidemie2.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Modifier etat actuel",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Enregistrer",
      cancleBtnContent: "Fermer",
    }

    this.popupalertepidemie2.show(this.popupalertepidemie2.options);
  }




  open() {
    this.popupConseil.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: this.titre_epidemie,
      widthProsentage: 70,
      animation: "fadeInUp",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupConseil.show(this.popupConseil.options);
    this.popupProcedure.hide();
  }


  open2() {
    this.popupProcedure.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: this.titre_epidemie,
      widthProsentage: 70,
      animation: "fadeInUp",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);

  }

  fermer() {
    this.popupProcedure.hide();
    this.popupConseil.hide();
    this.mode_epidemie_fermer = 1;
    this.mode_epidemie = 1;
  }



  fermerProcedure() {
    this.fermer();
  }


  fermerProcedure_() {
    let etat = "F"
    this.router.navigate(['detail-iec/' + 1 + "/" + etat]);
  }

  voirinfo() {
    this.mode_epidemie_video = 2;
    this.mode_actualiter_video = 1;
  }

  voirinfoVIDEO() {
    this.mode_epidemie_video = 1;
  }



  //apropos
  AjouterApropos() {
    this.popupApropos.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Formulaire à propos",
      widthProsentage: 50,
      animation: "fadeInRight",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupApropos.show(this.popupApropos.options);
    this.listeApropos();

  }




  listeApropos() {
    this.cmsService.getlisteApropos()
      .subscribe(data => {
        this.liste_apropos = data
      },
        err => {
          console.log(err);
        })
  }


  getInfoAproposbyId(id_appro: number) {
    this.cmsService.getInfoapropos(id_appro)
      .subscribe(data => {
        this.apropos = data

      },
        err => {
          console.log(err);
        })
  }

  annulerApropos() {
    this.apropos = new Apropos(null)
    this.popupApropos.hide();
  }


  saveApropos() {
    if (this.apropos.id_apropos == null) {
      //  this.apropos.etat_epid = "A";  
      this.apropos.date_ajou = new Date();
      this.cmsService.saveApropos(this.apropos).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.listeApropos();
        this.apropos = new Apropos(null)
        success_message.show();
        // this.popupApropos.hide();
      }, err => {
      })
    } else {
      this.cmsService.updateApropose(this.apropos).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.listeApropos();
        this.apropos = new Apropos(null)
        success_message.show();
        //this.popupApropos.hide();           
      }, err => {
      })
    }
  }







  deleteApropos(a: Apropos) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteApropos(a.id_apropos)
          .subscribe(data => {
            this.listeApropos();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }


  //modif Covid

  ModifierCMSCOVID(id: any) {
    if (id == 1) {
      //conseil
      this.mode_epidemieRecherche = 2;
      this.getInfoIECMSCOVID();
      if (this.loginuserCMSActuel == "com_daf") {
        //daf com
        this.mode_epidemie = 44;
        this.mode_epidemiecovidcmsconseil2 = 1;
        this.mode_epidemiecovidcmsconseil = 1;
        console.log('mode com');
      } else {
        //Agent
        console.log('mode Agent');
        this.mode_epidemie = 43;
      }


    } else {
      //cms  
      this.mode_epidemieRecherche = 2;
      this.getInfoIECDetailMSCOVID()

      if (this.loginuserCMSActuel == "com_daf") {
        //daf com
        console.log('mode com');
        this.mode_epidemie = 45;
        this.mode_epidemiecovidcmsconseil2 = 2;
        this.mode_epidemiecovidcmsconseil = 1;
      } else {
        //Agent
        console.log('mode Agent');
        this.mode_epidemie = 46;
      }

    }

  }


  ModifierCMSCOVID_(id: any) {
    if (id == 1) {
      //conseil
      this.mode_epidemieRecherche = 2;
      this.getInfoIECMSCOVID();
      console.log('mode Agent');
      this.mode_epidemie = 43;
    } else if (id == 3) {
      this.mode_epidemie = 63;
      this.mode_epidemieRecherche = 2;
    } else if (id == 4) {
      this.mode_epidemie = 64;
      this.mode_epidemieRecherche = 2;
    } else if (id == 5) {
      this.mode_epidemie = 100;
      this.mode_epidemieRecherche = 2;
    }else {
      //cms  
      this.mode_epidemieRecherche = 2;
      this.getInfoIECDetailMSCOVID()
      this.getGesteBarriere();
      //Agent
      console.log('mode Agent');
      this.mode_epidemie = 46;

    }

  }


  getGesteBarriere() {
    this.cmsService.getInfoGesteBarriere("C")
      .subscribe(data => {
        this.gesteBarriere = data
      },
        err => {
          console.log(err);
        })
  }

  AjouterFichier() {
    this.iecDetail = new IecDetail(null)
    this.mode_epidemiecovidcmsconseil = 2;
  }

  annulerIECCMS() {
    this.iecDetail = new IecDetail(null)
    this.mode_epidemiecovidcmsconseil = 1;
  }

  //Conseil
  getInfoIECMSCOVID() {
    this.cmsService.getListeIECDetail(1, "C1")
      .subscribe(data => {
        // Atao mireturn raw
        this.listeconseil = data
      },
        err => {
          console.log(err);
        })
  }


  //CMS
  getInfoIECDetailMSCOVID() {
    this.cmsService.getListeIECDetail(1, "C2")
      .subscribe(data => {
        // Atao mireturn raw
        this.listecmsdetatil = data
      },
        err => {
          console.log(err);
        })
  }



  getInfoIecDetail(r: Iec) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteIec(r.id_iec)
          .subscribe(data => {
            this.getIecFile();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }



  openpopupModif() {
    this.popupModifCovid.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Modifier CMS CONSEIL COVID",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter",
      cancleBtnContent: "Fermer",
    }

    this.popupModifCovid.show(this.popupModifCovid.options);
  }



  //mot  defil

  GererMotDefil() {
    this.getmot_defil();
    this.popupmotdefil();
    this.mot_defil = new Mot_defil(null)
  }


  getmot_defil() {
    this.adminService.getmot_defil()
      .subscribe(data => {
        this.liste_mot_defil = data;
      }, err => {

      })
  }


  getmot_defil_by_id(id_mot: number) {
    this.adminService.getmot_defil_by_id(id_mot)
      .subscribe(data => {
        this.mot_defil = data;
      }, err => {

      })
  }


  annulerMot() {
    this.mot_defil = new Mot_defil(null)
    this.popupMotDefil.hide();
  }

  savemotDefil() {
    // this.mot_defil.date_ajout = new Date();
    if (this.mot_defil.id_mot == null) {
      this.adminService.saveMot_defil(this.mot_defil).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.getmot_defil();
        this.mot_defil = new Mot_defil(null)
        success_message.show();
        //  this.popupMotDefil.hide();
      }, err => {
      })
    } else {
      this.adminService.updateMot_defil(this.mot_defil).subscribe(data => {
        if (data.err) {
          //toastr.error(data.err);return;
        }
        this.getmot_defil();
        this.mot_defil = new Mot_defil(null)
        success_message.show();
        //  this.popupMotDefil.hide();           
      }, err => {
      })
    }
  }



  deleteMot(a: Mot_defil) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.adminService.deleteMot(a.id_mot)
          .subscribe(data => {
            this.getmot_defil();
            success_message.show();
          }, err => {
            console.log('erreur de supression');
          })
      }
    })
  }

  popupmotdefil() {
    this.popupMotDefil.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Formulaire mot Accueil",
      widthProsentage: 50,
      animation: "fadeInRight",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupMotDefil.show(this.popupMotDefil.options);

  }


  //GererActualiter
  GererActualiterDefault() {
    this.mode_actualiter = 1;
  }

  GererActualiter() {
    this.mode_actualiter = 2;
  }

  AjouterActualiter() {
    this.mode_actualiter2 = 2;
    this.iec = new Iec(null)
  }


  AnnulerActualiter() {
    this.mode_actualiter2 = 1;
    this.iec = new Iec(null)
  }


  //gererInformationVideo

  gererInformationVideo_defaul() {
    this.mode_actualiter_video = 1;
  }

  gererInformationVideo() {
    this.mode_actualiter_video = 2;
  }

  gererInformationVideo2() {
    this.mode_epidemie_video = 1;
    this.mode_actualiter_video = 2;
  }


  AjouterActualiterVideo() {
    this.mode_actualiter_video2 = 2;
    this.iec = new Iec(null)
  }


  AnnulerActualiterVideo() {
    this.mode_actualiter_video2 = 1;
    this.iec = new Iec(null)
  }





  //gererInformationVideoSlide

  gererInformationSlide() {
    if (this.loginuserCMSActuel == "com_daf") {
      this.getIecInformationUtile();
      this.mode_epidemie_video = 2;
      this.mode_actualiter_video = 2;
    } else {
      // modeAgent
      this.getIecInformationUtile()
      this.mode_epidemie_video = 2;
      this.mode_actualiter_video = 1;
      this.mode_InformationSlide = 2;
    }

  }

  gererInformationSlide_() {
    this.mode_epidemie_video = 1;
    this.mode_InformationSlide = 1;
  }


  AjouterActualiterSlide() {
    this.mode_actualiter_slide2 = 2;
    this.iec = new Iec(null)
  }


  AnnulerActualiterSlide() {
    this.mode_actualiter_slide2 = 1;
    this.iec = new Iec(null)
  }



  //pagination*

  //   gotoPage(i: number) {
  //     if (i <= 0) return;
  //     if (i > this.infoIecVideo.length) return;
  //     this.currentPage = i;
  //  //   this.agent.infoEnregistrement.pageActu = this.currentPage;
  //     //this.doSearch();
  //    // this.getListStatistiqueAgent();
  //   }

  Sensibilisation() {
    if (this.mode_epidemie_ == 1) {
      this.mode_epidemie_ = 2;
      this.mot_cms_Sensibilisation = "Images";
    } else if (this.mode_epidemie_ == 2) {
      this.mode_epidemie_ = 1;
      this.mot_cms_Sensibilisation = "Sensibilisation";
    }
  }



  // popup detail


  popupnew(id_epi: any) {
    this.cmsService.getInfoEvolutionEpidemie(id_epi)
    .subscribe(data => {
      this.epidemimie = data
      console.log(this.epidemimie.image_actu);
      if(this.epidemimie.image_actu == null){
        this.statistique_actu = "alerte_corona.PNG";
        this.getinfoipdemie_();
       
      }else{
        this.statistique_actu = this.epidemimie.image_actu;
        this.getinfoipdemie_();
      }
      // this.epidemimie.image_actu
      // this.epidemimie.date_ajout
      // this.epidemimie.text_epid
    
    },
      err => {
        console.log(err);
      })
  }

  getinfoipdemie_() {
    this.popupalert.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "CENTRE DE COMMANDEMENT OPERATIONNRL COVID 19",
      widthProsentage: 60,
      animation: "fadeInUp",
      confirmBtnContent: "Autre",
      cancleBtnContent: "Fermer",
    }
    this.popupalert.show(this.popupalert.options);

  }


  


  voir() {
    this.popupalert.hide();
    this.epidemimie = new Epidemimie(null)
  }


  voir_() {
    this.popupalert.hide();
    this.epidemimie = new Epidemimie(null)
  }

}
